var constants = require('../constants');
var postUtils = require('../postUtils');

var postActions = (function() {

    var _requestPost = function(categorySlug) {
        return {
            type: constants.REQUEST_POST,
            categorySlug: categorySlug
        };
    };

    var _receivePost = function(categorySlug, data) {
        return {
            type: constants.RECEIVE_POST,
            categorySlug: categorySlug,
            data: data
        };
    };

    var _requestPostFailure = function(categorySlug, error) {
        return {
            type: constants.REQUEST_POST_FAILURE,
            categorySlug: categorySlug,
            errors: error.data || error
        };
    };

    var _fetchPost = function(categorySlug, name) {
        return function (dispatch) {
            dispatch(_requestPost(categorySlug));

            var queryObj = {
                'fields.slug': name,
                content_type: 'postContainer',

                include: 2
            };

            var categoryID = postUtils.categorySlug2CategoryID[categorySlug];

            if(categoryID){
                queryObj['fields.category.sys.id'] = categoryID;
            }

            return postUtils.contentfulClient.getEntries(queryObj).then(function (entries) {
                var parsedEntries = postUtils.contentfulClient.parseEntries(entries);
                parsedEntries.items[0].fields.clientExt_description = postUtils.extractDescriptionFromPostContainer(parsedEntries.items[0]);
                return dispatch(_receivePost(categorySlug, parsedEntries.items[0]));
            }).catch(function(error){
                dispatch(_requestPostFailure(categorySlug, error.response || error.message || ''));
            });
        };
    };

    var _shouldFetchPost = function(categorySlug, name, state) {
        if ((state.post[categorySlug] && state.post[categorySlug].data && state.post[categorySlug].data.fields.slug) === name) {
            return false;
        } else {
            return true;
        }
    };

    var _fetchPostIfNeeded = function(categorySlug, name) {
        return function(dispatch, getState) {
            var state = getState();
            if (_shouldFetchPost(categorySlug, name, state)) {
                return dispatch(_fetchPost(categorySlug, name));
            }
        };
    };

    var _setPost = function(categorySlug, data){
        return {
            type: constants.SET_POST,
            categorySlug: categorySlug,
            data: data
        };
    };

    return {
        fetchPostIfNeeded: _fetchPostIfNeeded,
        setPost: _setPost
    };
})();

module.exports = postActions;



// WEBPACK FOOTER //
// ./src/common/modules/posts/actions/post.js